/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Col, DatePicker, Form, Input, InputNumber, Select } from 'antd';

import Utils from '../../../../Assets/Scripts/Utils';
import { createShowField } from '../../../../Components/ResourceFieldLayout/shouldRenderTaskField';
import UploadFileField from '../UploadFileField';

function FormFinanceFieldsComponent({
  fieldsPermissions,
  reasonNoBillingOptions,
  invoiceIssuersOptions,
  handleTaskUpdate,
  form,
  task,
  setUploadFileType,
  setUploadFileModalOpen,
  isTaskReadOnly,
  isEditing,
  fieldLayout,
  roleId,
  fieldNameFilter,
  hideSectionCard,
}) {
  const showField = createShowField(fieldsPermissions, fieldLayout, roleId, fieldNameFilter);
  const inner = (
    <>
      {/* Valor Turma */}
      {showField('TrainingValue') && (
        <Col span={24}>
          <Form.Item name="trainingValue" label="Valor Turma">
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.TrainingValue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Valor Transporte */}
      {showField('TransportValue') && (
        <Col span={24}>
          <Form.Item
            name="transportValue"
            label="Valor Transporte"
            rules={[
              {
                required: fieldsPermissions?.TransportValue.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.TransportValue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Valor Turma + Valor Transporte */}
      {showField('TrainingAndTransportValue') && (
        <Col span={24}>
          <Form.Item name="trainingAndTransportValue" label="Valor Turma + Valor Transporte">
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.TrainingAndTransportValue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Data de Previsão de Faturamento */}
      {showField('BillingDeadlineDate') && (
        <Col span={24}>
          <Form.Item
            name="billingDeadlineDate"
            label="Data de Previsão de Faturamento"
            rules={[
              {
                required: fieldsPermissions?.BillingDeadlineDate.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{
                borderRadius: 16,
              }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.BillingDeadlineDate.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Razão de não Faturamento */}
      {showField('ReasonNoBilling') && (
        <Col span={24}>
          <Form.Item
            label="Razão de não Faturamento"
            name="reasonNoBilling"
            rules={[
              {
                required: fieldsPermissions?.ReasonNoBilling.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
            getValueFromEvent={(_, object) => {
              if (!object) return null;

              return {
                ...object,
                name: object.label,
                id: object.value,
              };
            }}
          >
            <Select
              options={reasonNoBillingOptions.map((reasonNoBillingOptions) => ({
                label: reasonNoBillingOptions.name,
                value: reasonNoBillingOptions.id,
              }))}
              allowClear
              placeholder="o campo está vazio"
              optionFilterProp="label"
              showSearch
              dropdownStyle={{ borderRadius: 16 }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ReasonNoBilling.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* NF Transporte - Upload (Campo desabilitado em todos os estágios) */}
      {false && showField('NFTransportation') && task.trainingTransportation === 'Incluso' && (
        <Col span={24}>
          <Form.Item label="NF Transporte" name="nfTransportation">
            <UploadFileField
              handleTaskUpdate={handleTaskUpdate}
              form={form}
              task={task}
              fieldName="nfTransportation"
              fieldPermission={fieldsPermissions?.NFTransportation}
              isTaskReadOnly={isTaskReadOnly}
              isEditing={isEditing}
              setUploadFileType={setUploadFileType}
              setUploadFileModalOpen={setUploadFileModalOpen}
            />
          </Form.Item>
        </Col>
      )}

      {/* NF Treinamento */}
      {showField('NFTraining') && (
        <Col span={24}>
          <Form.Item label="NF Treinamento" name="nfTraining">
            <UploadFileField
              handleTaskUpdate={handleTaskUpdate}
              form={form}
              task={task}
              fieldName="nfTraining"
              fieldPermission={fieldsPermissions?.NFTraining}
              isTaskReadOnly={isTaskReadOnly}
              isEditing={isEditing}
              setUploadFileType={setUploadFileType}
              setUploadFileModalOpen={setUploadFileModalOpen}
            />
          </Form.Item>
        </Col>
      )}

      {/* Número Nota Fiscal */}
      {showField('InvoiceNumber') && (
        <Col span={24}>
          <Form.Item
            name="invoiceNumber"
            label="Número Nota Fiscal"
            rules={[
              {
                required: fieldsPermissions?.InvoiceNumber.isRequired,
                message: 'Número Nota Fiscal',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.InvoiceNumber.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Data de Emissão da Nota Fiscal */}
      {showField('InvoiceEmissionDate') && (
        <Col span={24}>
          <Form.Item
            name="invoiceEmissionDate"
            label="Data de Emissão da Nota Fiscal"
            rules={[
              {
                required: fieldsPermissions?.InvoiceEmissionDate.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{
                borderRadius: 16,
              }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.InvoiceEmissionDate.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Emissor Nota Fiscal */}
      {showField('InvoiceIssuer') && (
        <Col span={24}>
          <Form.Item
            label="Emissor Nota Fiscal"
            name="invoiceIssuer"
            rules={[
              {
                required: fieldsPermissions?.InvoiceIssuer.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
            getValueFromEvent={(_, object) => {
              if (!object) return null;

              return {
                ...object,
                name: object.label,
                id: object.value,
              };
            }}
          >
            <Select
              options={invoiceIssuersOptions}
              allowClear
              placeholder="o campo está vazio"
              optionFilterProp="label"
              showSearch
              dropdownStyle={{ borderRadius: 16 }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.InvoiceIssuer.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Valor Nota Fiscal Total */}
      {showField('TotalInvoiceValue') && (
        <Col span={24}>
          <Form.Item
            name="totalInvoiceValue"
            label="Valor Nota Fiscal Total"
            rules={[
              {
                required: fieldsPermissions?.TotalInvoiceValue.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.TotalInvoiceValue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Valor Nota Fiscal Parcial */}
      {showField('PartialInvoiceValue') && (
        <Col span={24}>
          <Form.Item
            name="partialInvoiceValue"
            label="Valor Nota Fiscal Parcial"
            rules={[
              {
                required: fieldsPermissions?.PartialInvoiceValue.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.PartialInvoiceValue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Diferença de Alunos Treinados */}
      {showField('QtyStudentsDiff') && (
        <Col span={24}>
          <Form.Item
            label="Diferença Alunos Confirmados/Treinados"
            name="qtyStudentsDiff"
            rules={[
              {
                required: fieldsPermissions?.QtyStudentsDiff.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={true} placeholder="o campo está vazio" />
          </Form.Item>
        </Col>
      )}

      {/* Observação Omie */}
      {showField('OmieNotes') && (
        <Col span={24}>
          <Form.Item name="omieNotes" label="Observação Omie">
            <Input disabled={true} placeholder="o campo está vazio" />
          </Form.Item>
        </Col>
      )}
    </>
  );

  if (hideSectionCard) {
    return inner;
  }

  return (
    <Col span={24}>
      <Card title="Financeiro" bordered={false} className="task-form-section-card">
        {inner}
      </Card>
    </Col>
  );
}

export default FormFinanceFieldsComponent;
